<section class="lm-status-card day-status-card" aria-label="Day status">
  <button
    type="button"
    class="lm-status-card__toggle"
    [attr.aria-expanded]="expanded"
    [attr.aria-controls]="expanded ? groupsId : null"
    (click)="toggleExpanded()">
    <span class="lm-status-card__summary">
      <span class="lm-overline">{{ getToggleOverline() }}</span>
      <span class="lm-status-card__line">{{ getGlanceLine() }}</span>
    </span>
    <svg *ngIf="!expanded" lucideChevronDown class="lm-icon" aria-hidden="true"></svg>
    <svg *ngIf="expanded" lucideChevronUp class="lm-icon" aria-hidden="true"></svg>
  </button>

  <div *ngIf="celebrationCycle" class="lm-notice lm-notice--attention day-status-celebration" role="status">
    <strong>{{ celebrationCopy() }}</strong>
  </div>

  <div *ngIf="expanded" [id]="groupsId">
    <div class="lm-status-card__figures">
      <div class="lm-stat">
        <span class="lm-stat__value">{{ status.dayStartLabel }}</span>
        <span class="lm-stat__label">Started</span>
      </div>
      <div class="lm-stat">
        <span class="lm-stat__value">{{ status.projectedFinishLabel }}</span>
        <span class="lm-stat__label">Projected finish</span>
      </div>
      <div class="lm-stat">
        <span class="lm-stat__value">{{ status.dayWindowEndLabel }}</span>
        <span class="lm-stat__label">Window ends</span>
      </div>
      <div class="lm-stat">
        <span class="lm-stat__value">{{ getWindowSlackValue() }}</span>
        <span class="lm-stat__label">{{ getWindowSlackFigureLabel() }}</span>
      </div>
    </div>

    <div class="lm-status-card__cycles">
      <section
        *ngFor="let section of cycleSections; trackBy: trackSection"
        class="lm-status-card__cycle"
        [class.day-status-cycle--celebrating]="celebrationCycle === section.cycle"
        [attr.aria-label]="section.label + ' cycle'">
        <p class="lm-overline">
          <span *ngIf="section.hasActivities">{{ cycleProgressLabel(section) }}</span>
          <span *ngIf="!section.hasActivities">{{ section.label }}</span>
        </p>
        <div class="lm-meter" *ngIf="section.hasActivities" [attr.aria-hidden]="true">
          <span [style.width.%]="cycleMeterPercent(section)"></span>
        </div>
        <p *ngIf="!section.hasActivities" class="day-status-empty text-body-sm">No groups yet</p>
        <div
          class="lm-status-card__groups"
          [id]="dropListId(section.cycle)"
          cdkDropList
          cdkDropListOrientation="vertical"
          [cdkDropListDisabled]="reorderDisabled"
          (cdkDropListDropped)="onCycleGroupDrop(section.cycle, $event)">
          <button
            *ngFor="let group of section.groups; trackBy: trackGroup"
            type="button"
            class="lm-group-row"
            [attr.data-group-ordinal]="group.ordinal"
            [class.lm-group-row--done]="group.doneThisCycle"
            cdkDrag
            cdkDragLockAxis="y"
            [cdkDragStartDelay]="listDragStartDelay"
            [cdkDragDisabled]="reorderDisabled || group.doneThisCycle"
            (click)="selectGroup(group.ordinal)"
            (keydown)="onGroupKeydown($event, section.cycle, group)">
            <span class="lm-group-row__label">{{ group.label }}</span>
            <span class="lm-group-row__meta">
              <span>{{ group.doneCount }} of {{ group.totalCount }}</span>
              <span
                class="lm-days"
                [class.lm-days--quiet]="group.daysSince === 0"
                aria-hidden="true">
                {{ group.daysSinceLabel }}
              </span>
              <span class="lm-sr-only">, {{ daysSinceAriaLabel(group) }}</span>
            </span>
          </button>
        </div>
      </section>
    </div>

    <p *ngIf="lastCompletedCyclesCopy() as lastCyclesCopy" class="lm-status-card__foot">
      {{ lastCyclesCopy }}
    </p>
    <p class="lm-status-card__foot">
      Tap a group to open it. Press and hold to reorder.
      <span class="lm-sr-only">Alt + up or down to reorder.</span>
    </p>
  </div>
</section>
